export default __webpack_public_path__ + "static/media/gallery_08.3975cca0.jpg";